export const ComponentTokens = {
  "toggle": {
    "knob": {
      "disabled": {
        "onlight": {
          "value": "#f6f6f6"
        },
        "ondark": {
          "value": "#6f7171"
        }
      }
    },
    "container": {
      "on": {
        "onlight": {
          "value": "#008331"
        },
        "ondark": {
          "value": "#00b845"
        }
      }
    }
  },
  "tabs": {
    "indicator": {
      "onlight": {
        "value": "#ee0000"
      },
      "ondark": {
        "value": "#ffffff"
      }
    }
  },
  "tooltip": {
    "native": {
      "background": {
        "overlay": {
          "onlight": {
            "value": "rgba(0, 0, 0, 0.3)"
          },
          "ondark": {
            "value": "rgba(255, 255, 255, 0.3)"
          }
        }
      }
    },
    "container": {
      "hover": {
        "onlight": {
          "value": "rgba(111, 113, 113, 0.06)"
        },
        "ondark": {
          "value": "rgba(111, 113, 113, 0.26)"
        }
      }
    },
    "icon": {
      "active": {
        "secondary": {
          "onlight": {
            "value": "#a7a7a7"
          },
          "ondark": {
            "value": "#6f7171"
          }
        }
      }
    }
  },
  "modal": {
    "background": {
      "overlay": {
        "onlight": {
          "value": "rgba(0, 0, 0, 0.8)"
        },
        "ondark": {
          "value": "rgba(255, 255, 255, 0.8)"
        }
      }
    }
  },
  "buttonicon": {
    "background": {
      "semitransparent": {
        "onlight": {
          "value": "rgba(111, 113, 113, 0.06)"
        },
        "ondark": {
          "value": "rgba(111, 113, 113, 0.26)"
        }
      },
      "lowcontrast": {
        "floating": {
          "onlight": {
            "value": "#ffffff"
          },
          "ondark": {
            "value": "#333333"
          }
        }
      },
      "highcontrast": {
        "floating": {
          "onlight": {
            "value": "#333333"
          },
          "ondark": {
            "value": "#ffffff"
          }
        }
      }
    },
    "elements": {
      "lowcontrast": {
        "disabled": {
          "onlight": {
            "value": "#d8dada"
          },
          "ondark": {
            "value": "rgba(0, 0, 0, 0.7)"
          }
        }
      }
    }
  },
  "calendar": {
    "elements": {
      "secondary": {
        "selected": {
          "onlight": {
            "value": "#a7a7a7"
          },
          "ondark": {
            "value": "#6f7171"
          }
        }
      }
    }
  },
  "badgeindicator": {
    "gray": {
      "highcontrast": {
        "onlight": {
          "value": "#6f7171"
        },
        "ondark": {
          "value": "#a7a7a7"
        }
      },
      "lowcontrast": {
        "onlight": {
          "value": "#d8dada"
        },
        "ondark": {
          "value": "#333333"
        }
      }
    }
  }
}